<!--
 * @Author: M.D.
 * @Date: 2020-01-10 11:00:53
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="glg-out-r">
    <ul class="glg-ul" v-if="gdsData.length !== 0">
      <li
        class="glg-item-li"
        @click="goToGdsDetail(i)"
        v-for="(i, index) in gdsData"
        :key="index"
      >
        <div class="img-glg-img-w">
          <img
            :src="tImgUrl(i.image.split(',')[0])"
            class="image"
            :onerror="errImgDefault"
          />
          <img
            v-if="i.videoUrl"
            class="active-icon"
            src="~@/assets/image/active.png"
          />
        </div>
        <div class="gds-d-i-c-w">
          <div class="gds-d-name">{{ i.name }}</div>
          <div class="good_bottom">
            <div class="gds-d-rate">{{ goodInfo(i) }}</div>
            <div class="gds-d-i-bottom">
              <span
                class="gds-d-i-curP"
                v-if="i.type == 5"
                style="display: block"
              >
                {{ i.partnerName }}
              </span>
              <span class="gds-d-i-curP" v-if="i.type != 5">
                <span class="unit" v-if="i.isOnPay === 1">￥</span>
                {{ i.isOnPay !== 1 ? '价格面议' : `${getFinalPrice(i)}` }}
              </span>
              <span
                v-if="i.discountPrice !== -1 && i.isOnPay === 1"
                class="gds-d-i-orgP"
              >
                <span class="unit">￥</span>
                {{ i.price }}
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    gdsData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    goToGdsDetail(i) {
      if(this.type==3){
           this.$router.push({
        name: 'productvideo',
        params: { prodId: i.id, type: this.type },
      })
      return
      }
      this.$router.push({
        name: 'productDetail',
        params: { prodId: i.id, type: this.type },
      })
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.glg-out-r {
  // margin-top 20px
  // padding-left 20px
  // padding-right 20px
  // background-color #ffffff
  .glg-ul {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    padding: 20px 0 10px 0;

    .glg-item-li {
      // background-color red
      width: 270px;
      height: 298px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(174, 85, 0, 0.2);
      border-radius: 8px;
      margin-bottom: 40px;
      margin-right: 40px;
    

      .img-glg-img-w {
        height: 200px;
        width: 100%;
        .image {
         width:100%;
         height: 200px;
        }
      }

      .gds-d-i-c-w {
        height: 98px;

        .gds-d-name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-family: AdobeHeitiStd-Regular;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          padding: 20px 10px;
          letter-spacing: 0px;
          color: #333333;
        }

        .good_bottom {
          display: flex;
           padding: 0px 10px;
          height: 25px;
          justify-content: space-between;
          align-items: center;
        }

        .gds-d-rate {
          white-space: pre-wrap;
          margin: 8px 0;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #999999;
        }

        .gds-d-i-bottom {
          font-size: 24px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #ff7a00;
          .gds-d-i-curP {
            // width 100px
            // display -webkit-box
            // -webkit-box-orient vertical
            // -webkit-line-clamp 2
            word-break: break-all;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: orange-color;
            margin-right: 12px;
            font-size: 20px;

            .unit {
              font-size: 16px;
            }
          }

          .gds-d-i-orgP {
            font-size: 14px;
            color: #999999;
            text-decoration: line-through;
          }
        }
      }
    }
  }

}
.glg-ul :nth-child(4n+4) { 
     margin-right: 0 !important;
} 
</style>
